import { TypographyProps } from '@mui/material'
import { Typography } from 'components/Material/index'
import { colorFontSmallTitle, lightOnSurface } from 'styles/useTextStyles'

interface TitleTextProps extends TypographyProps {
  text: string | number
  typeStyle: 'medium' | 'large' | 'small'
}

export const TitleText: React.FC<TitleTextProps> = ({ text, typeStyle, ...props }) => {
  return (
    <Typography sx={styles[typeStyle]} {...props}>
      {text}
    </Typography>
  )
}

const styles = {
  large: {
    fontSize: '22px',
    lineHeight: '28px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Bold'
  },
  medium: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontFamily: 'BB-Font-Medium'
  },
  small: {
    fontSize: '14px',
    fontFamily: 'BB-Font-Medium',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: colorFontSmallTitle
  }
}
